import React from 'react';
import { RefreshCw, Moon, Sun } from 'lucide-react';
import styles from '../PriceChangeLogs/PriceChangeLogs.module.css';
import SyncVerificationLogsPanel from './SyncVerificationLogsPanel';

const SyncVerificationLogs: React.FC = () => {
  const [refreshSignal, setRefreshSignal] = React.useState(0);
  const [isDarkMode, setIsDarkMode] = React.useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) return saved === 'dark';
    return document.documentElement.getAttribute('data-theme') === 'dark';
  });

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const handleRefresh = () => {
    setRefreshSignal((signal) => signal + 1);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          <h1>Sync Verification Logs</h1>
          <p>
            All QuickAsyst ↔ Victory Live sync failures — from share, unshare, price sync, split,
            and manual verification. Each Failure calls out exactly what differs (marketplaces,
            price, shared status, etc.) so it can be fixed manually.
          </p>
        </div>
        <div className={styles.headerActions}>
          <div className={styles.iconButtons}>
            <button
              type="button"
              className={styles.iconButton}
              onClick={handleRefresh}
              title="Refresh"
              aria-label="Refresh logs"
            >
              <RefreshCw size={18} />
            </button>
            <button
              type="button"
              className={styles.iconButton}
              onClick={() => setIsDarkMode(!isDarkMode)}
              title={isDarkMode ? 'Light mode' : 'Dark mode'}
              aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
            </button>
          </div>
        </div>
      </div>

      <SyncVerificationLogsPanel refreshSignal={refreshSignal} />
    </div>
  );
};

export default SyncVerificationLogs;
